import React from "react"
import Link from "@material-ui/core/Link";
import SharpImage from "../utils/sharpImage"
import HtmlContent from "../utils/htmlContent"
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import StyledButton from "../common/styledButton";
import FeaturedEventStyles from "./featuredEvent.styles";
import StyledLink from '../common/styledLink';

export const FeaturedEvent = ({ event }) => {
    const classes = FeaturedEventStyles();
    //TODO: this should be passed in, path is site-specific
    const toPath = "eventers/" + event.slug;
    const featuredImage = event.featuredImage || event.post.featuredImage;
    const excerpt = event.excerpt || (event.content && (event.content.excerpt || event.content.rendered)) || event.content;
    return (
        <div className={classes.featuredEventContainer}>
            {featuredImage ?
                <div className={classes.featuredEventImgContainerStyles}>
                    <SharpImage file={featuredImage.node.localFile} title={featuredImage.node.title} altText={featuredImage.node.altText} />
                </div>
                : <div className={classes.featuredEventImgContainerStyles}>ToDo: no feature image placeholder?</div>}

            <Box className={classes.featuredEventSummaryContainer}>
                <div className={classes.featuredEventTitleMargin}>
                    <Typography variant="h4"><Link href={toPath} color="inherit">Next<br />Event</Link></Typography>
                    <div>{event.title}</div>
                    <div>{event.venue && event.venue.address}</div>
                    <span>{event.dueIn}</span>
                </div>

                <HtmlContent content={excerpt} />
                <StyledButton component={StyledLink} href={toPath} variant="contained" className={classes.featuredEventButtonStyle}>Register Here</StyledButton>
            </Box>

        </div>
    );
}

export default FeaturedEvent
